var map = {
	"./staging_new_h_quiz_variant_1.json": [
		28432,
		8432
	],
	"./staging_new_h_quiz_variant_2.json": [
		86580,
		6580
	],
	"./staging_new_t_quiz_variant_1.json": [
		96598,
		6598
	],
	"./staging_new_t_quiz_variant_2.json": [
		77522,
		7522
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 62097;
module.exports = webpackAsyncContext;